import { render, staticRenderFns } from "./CompetitionEmptyDefaultLayout.vue?vue&type=template&id=72868a8c&scoped=true"
import script from "./CompetitionEmptyDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionEmptyDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72868a8c",
  null
  
)

export default component.exports